import { CFC } from "@api/types/cypress";
import React from "react";

const MultiCheckbox: CFC<{
  field: string;
  label: string;
  value: string;
  checked: boolean;
  onChange: (field: string, value: string, checked: boolean) => void;
}> = ({ field, label, value, checked, onChange }) => (
  <div>
    <input
      checked={checked}
      value={value}
      type="checkbox"
      onChange={({ target: { value, checked } }) => {
        onChange(field, value, checked);
      }}
    />
    <span>{label}</span>
  </div>
);

export default MultiCheckbox;
